import { createStore } from '@stencil/store';

const { state, onChange } = createStore({
  term: '',
  answers: [],
});

const faqWidgetStore = {
  state,
  onChange
};

export default faqWidgetStore;
